export default {"src":"/_next/static/media/question-mark-slateus.1e96b4ef.svg","height":100,"width":100};